export const ROUTE = {
    name: 'notifications',
    path: '/notifications',
};
export const ITEM_STATES = {
    list: ['unread', 'saw', 'read'],
    initial: 'unread',
    finite: 'read',
};
export const RETRY_DELAY = 10000;
export const FETCH_PARAMS = {
    page: 1,
    page_size: 20,
};
export const GROUP_BY = 'formattedDate';

export const DATE_PATTERN = 'd MMMM yyyy';
export const TIME_PATTERN = 'HH:mm';

export const INITIAL_STATE = 'idle';
export const TRANSITIONS = {
    idle: {
        FETCH: 'fetching',
    },
    fetching: {
        SUCCESS: 'reading',
        FAILED: 'failed',
    },
    reading: {
        UPDATE: 'updating',
        FAILED: 'failed',
        FETCH: 'fetching',
        REDIRECT: 'redirecting',
    },
    updating: {
        REFETCH: 'fetching',
        SUCCESS: 'reading',
        FAILED: 'failed',
    },
    redirecting: {
        UPDATE: 'updating',
        FAILED: 'failed',
    },
    failed: {},
    reset: {
        DONE: 'idle',
    },
};
